<template>
  <section
    :aria-labelledby="headingId"
    class="ViewProgramDetails"
  >
    <header class="ViewProgramDetails__header">
      <BaseInvisible
        :id="headingId"
        tag="h2"
      >Program Details</BaseInvisible>
      <div class="ViewProgramDetails__meta">
        <BaseImage
          v-if="badge"
          :id="badge"
          class="badge"
        />
        <LinkCta
          :href="mailto"
          class="link link__small"
        >Sign Up Now</LinkCta>
      </div>
      <ProgramAttributes
        v-if="attributes"
        :attributes="attributes"
        class="attributes"
      />
    </header>
    <div
      v-if="overview"
      class="ViewProgramDetails__overview"
      v-html="overview"
    />
    <ViewProgramDetailsSeasons
      v-if="seasons"
      :seasons="seasons"
      :mailto="mailto"
      class="ViewProgramDetails__seasons"
    />
  </section>
</template>

<script>
  import ProgramAttributes from './ProgramAttributes';
  import ViewProgramDetailsSeasons from './ViewProgramDetailsSeasons';
  import LinkCta from './LinkCta';

  export default {
    components: {
      ProgramAttributes,
      ViewProgramDetailsSeasons,
      LinkCta,
    },
    props: {
      badge: {
        type: [Number, Boolean],
        default: null,
      },
      seasons: {
        type: Array,
        default: null,
      },
      attributes: {
        type: Array,
        default: null,
      },
      mailto: {
        type: String,
        default: null,
      },
      overview: {
        type: String,
        default: null,
      },
    },
    computed: {
      headingId() {
        return `heading_${this._uid}`;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .attributes {
    width: 100%;
    margin-top: spacing(base-gamma);

    @include breakpoint(phablet) {
      width: 50%;
      margin-left: auto;
      margin-top: 0;
    }
  }

  .ViewProgramDetails__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @include breakpoint(phablet) {
      align-items: flex-start;
      flex-direction: column;
    }

    @include breakpoint(tablet) {
      justify-content: center;
    }
  }

  .link__small {
    display: inline-flex;
    text-align: center;

    @include breakpoint(phablet) {
      margin-top: spacing(base-gamma);
    }

    @include breakpoint(tablet) {
      display: none!important;
    }
  }

  .badge {
    width: 75px;

    @include breakpoint(phablet) {
      width: 100px;
    }
  }

  .ViewProgramDetails {
    @include column;

    width: 100%;
    margin-right: auto;
    margin-left: auto;

    @include breakpoint(phablet) {
      width: percentage(10/ 12);
    }
  }

  .ViewProgramDetails__header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include breakpoint(phablet) {
      align-items: stretch;
      flex-direction: row;
    }
  }

  .ViewProgramDetails__seasons {
    .ViewProgramDetails__header + & {
      margin-top: spacing(base-epsilon);
    }
  }

  .ViewProgramDetails__overview {
    margin-top: spacing(base-delta);
    margin-bottom: spacing(base-delta) * 2;
    line-height: line-height(copy);
  }
</style>
